/* Lastoya theme — product page: qty stepper + price-aware add-to-cart label */
(() => {
  'use strict';

  const currency = document.body.dataset.currency || 'USD';
  const money = (cents) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);

  const form = document.querySelector('[data-product-form]');
  if (!form) return;

  const qtyValue = form.querySelector('[data-qty-value]');
  const decrease = form.querySelector('[data-qty-decrease]');
  const increase = form.querySelector('[data-qty-increase]');
  const priceEl = form.querySelector('[data-unit-price]');
  const addBtn = form.querySelector('[data-add-to-cart]');
  const addLabel = form.querySelector('[data-add-label]');
  const unitCents = priceEl ? parseInt(priceEl.dataset.priceCents, 10) || 0 : 0;
  const available = addBtn && !addBtn.disabled;
  let qty = 1;

  const render = () => {
    qtyValue.textContent = String(qty);
    decrease.disabled = qty <= 1;
    if (available && addLabel && unitCents > 0) {
      addLabel.textContent = `Add to Cart — ${money(unitCents * qty)}`;
    }
  };

  decrease.addEventListener('click', () => {
    if (qty > 1) {
      qty -= 1;
      render();
    }
  });
  increase.addEventListener('click', () => {
    qty += 1;
    render();
  });

  render();
})();
